// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__7S0Tw","filesListContainer":"PosDisputesFiles_filesListContainer__1x2FU","filesButton":"PosDisputesFiles_filesButton__1ONR3"};